export const translations = {
  fr: {
    navHome: "Accueil",
    navAbout: "À propos",
    navVehicles: "Véhicules",
    navContact: "Contact",

    heroTitle: "Achetez et vendez vos voitures d’occasion en toute confiance",
    heroText:
      "CAR DOC est une société marocaine spécialisée dans l’achat et la vente de véhicules d’occasion. Nous vous accompagnons à chaque étape pour sécuriser votre transaction.",
    heroBtnContact: "Demander un devis",
    heroBtnAbout: "En savoir plus",
    heroBtnWhatsApp: "WhatsApp",

    heroBadge1: "Inspection complète",
    heroBadge2: "Vérification des documents",
    heroBadge3: "Transaction sécurisée",

    aboutTitle: "À propos de CAR DOC",
    aboutText1: "CAR DOC est spécialisée dans l’achat et la vente de voitures d’occasion au Maroc.",
    aboutText2:
      "Nous accompagnons nos clients pour acheter ou vendre leur véhicule en toute sécurité, avec inspection complète et vérification rigoureuse des documents.",
    aboutText3:
      "Notre objectif : garantir une transaction transparente, rapide et fiable, pour une expérience 100% sereine.",

    aboutStat1: "Véhicules traités",
    aboutStat2: "Clients satisfaits",
    aboutStat3: "Assistance disponible",

    servicesTitle: "Nos services",
    service1Title: "Inspection véhicule",
    service1Text: "Contrôle mécanique, carrosserie et essais.",
    service2Title: "Vérification des documents",
    service2Text: "Carte grise, historique, conformité, etc.",
    service3Title: "Estimation gratuite",
    service3Text: "Prix réaliste selon le marché et l’état.",
    service4Title: "Accompagnement transaction",
    service4Text: "Conseils, négociation et sécurisation du paiement.",

    vehiclesTitle: "Nos Véhicules",
    prev: "Précédent",
    next: "Suivant",
    viewDetails: "Voir détails",
    backToVehicles: "Retour aux véhicules",

    contactTitle: "Contactez CAR DOC",
    contactName: "Nom complet",
    contactEmail: "Adresse email",
    contactPhone: "Numéro de téléphone",
    contactMessage: "Votre message",
    contactBtn: "Envoyer",

    hoursTitle: "Horaires",
    hoursLine1: "Lun–Sam : 09:00 – 20:00",
    hoursLine2: "Dim : Sur rendez-vous",
    quickWhatsApp: "WhatsApp rapide",
  },

  ar: {
    navHome: "الرئيسية",
    navAbout: "من نحن",
    navVehicles: "السيارات",
    navContact: "اتصل بنا",

    heroTitle: "بيع وشراء السيارات المستعملة بثقة",
    heroText:
      "CAR DOC شركة مغربية متخصصة في بيع وشراء السيارات المستعملة. نحن نرافقك في كل خطوة لضمان صفقة آمنة وموثوقة.",
    heroBtnContact: "طلب عرض",
    heroBtnAbout: "المزيد",
    heroBtnWhatsApp: "واتساب",

    heroBadge1: "فحص شامل",
    heroBadge2: "التحقق من الوثائق",
    heroBadge3: "معاملة آمنة",

    aboutTitle: "حول CAR DOC",
    aboutText1: "CAR DOC متخصصة في بيع وشراء السيارات المستعملة في المغرب.",
    aboutText2:
      "نرافق عملائنا لشراء أو بيع سياراتهم بأمان، مع فحص شامل والتحقق الدقيق من جميع الوثائق.",
    aboutText3:
      "هدفنا: ضمان معاملة شفافة، سريعة وموثوقة لتجربة مريحة تمامًا.",

    aboutStat1: "عدد السيارات المعالجة",
    aboutStat2: "الزبائن الراضون",
    aboutStat3: "الدعم متاح",

    servicesTitle: "خدماتنا",
    service1Title: "فحص السيارة",
    service1Text: "فحص ميكانيكي وهيكل وتجربة قيادة.",
    service2Title: "التحقق من الوثائق",
    service2Text: "البطاقة الرمادية، التاريخ، المطابقة…",
    service3Title: "تقييم مجاني",
    service3Text: "سعر واقعي حسب السوق والحالة.",
    service4Title: "مرافقة الصفقة",
    service4Text: "نصيحة، تفاوض، وتأمين الدفع.",

    vehiclesTitle: "سياراتنا",
    prev: "السابق",
    next: "التالي",
    viewDetails: "عرض التفاصيل",
    backToVehicles: "العودة إلى السيارات",

    contactTitle: "تواصل مع CAR DOC",
    contactName: "الاسم الكامل",
    contactEmail: "البريد الإلكتروني",
    contactPhone: "رقم الهاتف",
    contactMessage: "رسالتك",
    contactBtn: "إرسال",

    hoursTitle: "مواعيد العمل",
    hoursLine1: "الإثنين–السبت: 09:00 – 20:00",
    hoursLine2: "الأحد: حسب موعد",
    quickWhatsApp: "واتساب سريع",
  },
};
